import React from 'react'
import { graphql } from 'gatsby'
import Layout from '../components/layout'
import Seo from '../components/seo'
import Article from '../components/articleDetailed'
import Spacer from '../components/spacer'

export default function News({ data }) {
    console.log(data.article.title)
    return (
        <Layout>
            <Seo title={data.article.title} />
            <Spacer />
            <div className='p10'> 
                <Article article={data.article} />
            </div>
        </Layout>
    )
}


export const query = graphql`
     query News($id: String ){
        article:datoCmsNews(id:{eq:$id}) {
            title
            slug
            website
            category {
                name
            }
            meta {
                publishedAt(formatString: "DD MMM Y")
            }
        }
     }
`